import { actionConst } from '../constants/warranty.constants';

const defaultState = {
	warrantyModalVisible: false,
	warrantyInfoModalVisible: false,
	newWarranty: 0,
	request: undefined,
	setWarrantyRequestID: undefined,
	fileTypesRef: [],
	warrantyInfo: {organization:{}},
	postWarrantyRequestId: null,
	infoPosted: false,
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {		
		case actionConst.FETCH_FILETYPES_REF + '_FULFILLED': {
			return {
				...state,
				fileTypesRef: action.payload.data.data || action.payload.data
			}
		}
		case actionConst.SHOW_WARRANTY_STATE_OK: {
			return {
				...state,
				setWarrantyRequestID: action.payload.reqn,
				//newWarranty: action.payload.ns
			}
		}
		case actionConst.HIDE_WARRANTY_STATE_OK: {
			return {
				...state,
				setWarrantyRequestID: undefined,
				//newWarranty: action.payload.ns
			}
		}
		case actionConst.OPEN_WARRANTY_MODAL: {
			return {
				...state,
				warrantyModalVisible: true,
				newWarranty: action.payload,
				request: action.id
			}
		}
		case actionConst.CLOSE_WARRANTY_MODAL: {
			return {
				...state,
				warrantyModalVisible: false
			}
		}

		case actionConst.OPEN_WARRANTY_INFO_MODAL: {
			return {
				...state,
				warrantyInfoModalVisible: true,
				warrantyInfo: action.payload.i,
				request: action.payload.r,
			}
		}
		case actionConst.CLOSE_WARRANTY_INFO_MODAL: {
			return {
				...state,
				warrantyInfoModalVisible: false
			}
		}

		case actionConst.POST_WARRANTY_INFO_OK: {
			return {
				...state,
				postWarrantyRequestId: action.payload,
				infoPosted: true,
			}
		}

		case 'POST_WARRANTY_INFO_RESET': {
			return {
				...state,
				infoPosted: false,
				postWarrantyRequestId: null,
			}
		}

		default:
			return state;
	}
}